import { apiClient } from './ApiClient';
import { API_ENDPOINTS } from '../../shared/constants';
import { ApiResponse, UploadXmlRequest, UploadXmlResponseData } from '../../shared/types';

export class XmlApi {
    static async upload(
        transactionId: number,
        xmlContent: string,
        token: string
    ): Promise<boolean> {
        const requestData: UploadXmlRequest = {
            idtransacao: transactionId,
            xmlcontent: xmlContent,
        };

        try {
            const response = await apiClient.post<ApiResponse<UploadXmlResponseData>>(
                API_ENDPOINTS.uploadXml,
                requestData,
                token
            );

            return response.success;
        } catch (error) {
            console.error('Error uploading XML:', error);
            throw error;
        }
    }
}

